"use client";

// src/components/logo/logo.tsx
import { useCallback, useState } from "react";
import { logo } from "./logo.styles.mjs";
import { jsx } from "react/jsx-runtime";
var logoSizes = {
  xs: "36",
  sm: "54",
  md: "72",
  lg: "96"
};
var Logo = ({
  ref,
  src,
  alt,
  className,
  size = "md",
  lazy = true,
  onError,
  width,
  height
}) => {
  const [error, setError] = useState(false);
  const logoSize = logoSizes[size];
  const style = logo({ size });
  const loading = lazy ? "lazy" : "eager";
  const handleError = () => {
    setError(true);
    onError?.();
  };
  const callbackRef = useCallback(
    (img) => {
      if (ref) {
        if (typeof ref === "function") ref(img);
        else if (typeof ref === "object") {
          ref.current = img;
        }
      }
      if (!img) {
        return;
      }
      img.src = img.src;
    },
    [ref]
  );
  if (error || !src) {
    const initial = alt.charAt(0).toUpperCase();
    return /* @__PURE__ */ jsx(
      "div",
      {
        role: "presentation",
        className: style.initialsContainer({
          className: className?.initialsContainer
        }),
        children: initial
      }
    );
  }
  return /* @__PURE__ */ jsx(
    "img",
    {
      ref: callbackRef,
      src,
      alt,
      className: style.image({ className: className?.image }),
      width: width ?? logoSize,
      height: height ?? logoSize,
      loading,
      onError: handleError
    }
  );
};
export {
  Logo
};
